import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import { getBanners } from '../../store/actions/general.actions';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { WindowSharp } from '@mui/icons-material';

function Banner() {
    const dispatch = useDispatch();
    const { banners, bannersLoading } = useSelector((state) => state.general);

    useEffect(() => {
        dispatch(getBanners());
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        margin: 10,
        autoplay: true,
        prevArrow: <button><NavigateBeforeRoundedIcon /></button>,
        nextArrow: <button><NavigateNextRoundedIcon /></button>,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    autoplay: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                },
            },
        ],
    };

    const handleReadMore = (link) => {
        window.open(link, "_blank");
    }
    return (
        <div className="banner-img w-100">
            <div className="mob-home-banner home-banner">

                <Slider {...settings}>
                    {banners.map((items) => {
                        return (
                            <div key={items.id}>
                                <div className='banner-wrp'>
                                    <img src={items.mobile} alt="poster" width="100%" onClick={() => { window.open(items.link, "_blank") }}/>
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </div>

            <div className="desktop-home-banner home-banner">
                <Slider {...settings}>
                    {banners.map((items) => {
                        return (
                            <div key={items.id}>
                                <div className='banner-wrp'>
                                    <img src={items.img_url} alt="poster" width="100%" onClick={() => { window.open(items.link, "_blank") }}/>
                                </div>

                            </div>
                        );
                    })}
                </Slider>
            </div>
        </div>
    );
}

export default Banner;
